import DeviceName from './DeviceName'

export default DeviceName
